export default {"src":"/_next/static/media/clear-input.094ed795.svg","height":20,"width":20};